// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"286":"3776fc24","453":"55422f07"}[chunkId] + ".chunk.js";
};